module.exports = __webpack_public_path__ + "static/logo-8d8e37fc65b6f71467d40b989f19ab2f.png";